export default __webpack_public_path__ + "static/media/photo11.cd6b108b.jpg";